import React from "react";
import {Title} from "../../../components/components";
import CmpConfiguration from "../../../components/cmp/CmpConfiguration";
import {useGetCmpAppsQuery} from "../../../api/cmpApiSlice";
import {useCreateAppGroupMutation} from "../../../api/appGroupApiSlice";
import CmpApps from "../../../components/cmp/CmpApps";
import {CmpPreview} from "../../../components/cmp/CmpPreview";
import usePublisherCmpConfiguration from "../../api_hooks/usePublisherCmpConfiguration";
import {useGetCurrentUserQuery} from "../../../api/userApiSlice";

export default function CmpDefaultPublisherPublisherConfiguration(props) {
  const {data: {publisherId} = {}, isSuccess} = useGetCurrentUserQuery()

  const params = {configurableType: 'publisher', configurableId: publisherId}

  const {data: apps = {}, isSuccess: isAppsSuccess} = useGetCmpAppsQuery(params, {skip: !publisherId})
  const {cmpPreviewProps, cmpConfigurationProps} = usePublisherCmpConfiguration({...params, skip: !publisherId})
  const [createAppGroup] = useCreateAppGroupMutation()

  return (
    <>
      <Title main="CMP" sub="Configuration"/>
      <CmpConfiguration {...cmpConfigurationProps}>
        <CmpApps
          icon={"app"}
          as={"cmp.apps"}
          apps={apps}
          setAppPreviewId={cmpPreviewProps.setAppPreviewId}
          createAppGroup={createAppGroup}
          publisherId={publisherId}/>
      </CmpConfiguration>
      <CmpPreview {...cmpPreviewProps} />
    </>
  )
}
